import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router';
import './ThemeCard.css';

const typeHelper = (url) => {
    switch (url.slice(url.lastIndexOf('.') + 1)) {
        case 'mp4':
            return true;
        case 'gif':
            return true;
        case 'png':
            return false;
        case 'jpeg':
            return false;
        case 'jpg':
            return false;
        default:
            return false;
    };
};

// card for each theme
const ThemeCard = (props) => {
    const { theme, selectTheme, create, currentTheme, handleDeleteTheme, newThemeAllowed } = props;

    const [ hover, setHover ] = useState('');
    const [ showDelete, setShowDelete ] = useState(false);
    const [ showFullMessage, setShowFullMessage ] = useState(false);
    const [ wizard ] = useState(window.location.pathname.includes('wizard'));
    
    const motion = typeHelper(theme.background);
    const cardRef = useRef(null);

    // Card JSX
    const [ card ] = useState(
        <>
            <div className='theme-card-top-card' style={{background: theme.top_card_color}}>
                {motion ?
                    <div style={{width: '100%', height: '4.5rem', background: '#eee', color: '#888'}} className='d-flex justify-content-center align-items-center'>Motion File</div>
                    :
                    <img className='theme-card-background' src={theme.background} alt='card background' />
                }
                <div className='theme-card-profile-pic' style={{borderColor: theme.profile_img_border}}>
                    <img src='/images/BitBlue-Person-Default-Profile-Picture.png' alt='default profile person' />
                </div>
                <div className='theme-card-top-card-words' style={{textShadow: `0 0 6px ${theme.top_text_color}`}}>
                    <div>First Last</div>
                    <div>Catch Phrase</div>
                    <div>Occupation at Work</div>
                </div>
            </div>
            <div className='theme-card-bottom-card' style={{background: theme.btm_card_color}}>
            <div className='theme-card-top-btns'>
                <div style={{background: theme.btn_color, textShadow: `0 0 3px ${theme.btm_text_color}`, borderColor: theme.btm_card_color, color: 'transparent'}}>Download</div>
                <div style={{background: theme.btn_color, textShadow: `0 0 3px ${theme.btm_text_color}`, borderColor: theme.btm_card_color, color: 'transparent'}}><i className='fas fa-user-plus' /></div>
            </div>
            <div className='theme-card-btn' style={{background: `linear-gradient(to right, transparent 10%, ${theme.btn_color} 25%, ${theme.btn_color})`}}>
                <div className='theme-card-icon'>
                    <i className='fas fa-phone' style={{background: theme.icon_color}} />
                </div>
                <div className='theme-card-btn-words' style={{color: 'transparent', textShadow: `0 0 5px ${theme.btm_text_color}`}}>
                    <div>Phone</div>
                </div>
                <div className='theme-card-arrow' style={{color: theme.btm_text_color}}>
                    <i className='fas fa-arrow-right' />
                </div>
            </div>
            <div className='theme-card-btn' style={{background: `linear-gradient(to right, transparent 10%, ${theme.btn_color} 25%, ${theme.btn_color})`}}>
                <div className='theme-card-icon'>
                    <i className='fab fa-chrome' style={{background: theme.icon_color}} />
                </div>
                <div className='theme-card-btn-words' style={{color: 'transparent', textShadow: `0 0 5px ${theme.btm_text_color}`}}>
                    <div>Website</div>
                </div>
                <div className='theme-card-arrow' style={{color: theme.btm_text_color}}>
                    <i className='fas fa-arrow-right' />
                </div>
            </div>
            <div className='theme-card-btn' style={{background: `linear-gradient(to right, transparent 10%, ${theme.btn_color} 25%, ${theme.btn_color})`}}>
                <div className='theme-card-icon'>
                    <i className='fas fa-envelope' style={{background: theme.icon_color}} />
                </div>
                <div className='theme-card-btn-words' style={{color: 'transparent', textShadow: `0 0 5px ${theme.btm_text_color}`}}>
                    <div>Email</div>
                </div>
                <div className='theme-card-arrow' style={{color: theme.btm_text_color}}>
                    <i className='fas fa-arrow-right' />
                </div>
            </div>
        </div>
        </>
    );

    useEffect(() => {
        const card = cardRef.current;

        if (!hover) {
            setShowDelete(false);
        };

        const handleMouseOver = (e) => {
            if (cardRef.current && cardRef.current.contains(e.target)) {
                card?.classList.add('active');
                setHover(theme.theme_name);
            } else {
                card?.classList.remove('active');
                setShowFullMessage(false);
                setHover('');
            };
        };

        if (window.innerWidth > 768) {
            document.addEventListener('mouseover', handleMouseOver);
            return () => document.removeEventListener('mouseover', handleMouseOver);
        } else {
            document.addEventListener('click', handleMouseOver);
            return () => document.removeEventListener('click', handleMouseOver);
        };
    },[hover, theme.theme_name]);

    useEffect(() => {
        const templateBtn = document.querySelector('.theme-card-template-btn-full');
        const question = document.querySelector('.theme-card-full-words');
        const yesNo = document.querySelector('.theme-card-yes-no');
        if (showFullMessage) {
            templateBtn?.classList.add('active');
            question?.classList.add('active');
            yesNo?.classList.add('active');
        } else {
            templateBtn?.classList.remove('active');
            question?.classList.remove('active');
            yesNo?.classList.remove('active');
        };
    }, [showFullMessage]);

    useEffect(() => {
        const deleteBtn = document.querySelector('.theme-card-delete');
        if (showDelete) {
            deleteBtn?.classList.add('expand');
        } else {
            deleteBtn?.classList.remove('expand');
        };
    },[showDelete]);

    if (create) {
        return (
            <div className='theme-card-create' ref={cardRef} style={{border: '2px dashed #364957'}}>
                <div className={hover === theme.theme_name ? 'theme-card-hover-text' : 'theme-card-hover-text active'}>Get Creative!</div>
                <div className='theme-card-btns'>
                    <Link 
                        to='/settings/themes/editor'
                        state={{ themeType: 'new', themeId: '0', deleteParam: false }}
                        style={{textDecoration: 'none'}}
                    >
                        <div className={hover === theme.theme_name ? 'theme-card-select-btn' : 'theme-card-select-btn active'}>New Theme</div>
                    </Link>
                </div>
            </div>
        )
    } else if (currentTheme && !wizard) {
        return (
            <div className='theme-card-current-wrap'>
                <div className='theme-card-current' ref={cardRef} style={{background: theme.main_background}}>
                    {hover === theme.theme_name ?
                        <>
                        <div className='theme-card-hover-text' style={{borderRadius: '.5rem'}}></div>
                        <div className='theme-card-btns'>
                            <Link 
                                to='/settings/themes/editor'
                                state={{ themeType: theme.type, themeId: theme.id, deleteParam: false }}
                                style={{textDecoration: 'none'}}
                            >
                                <div className='theme-card-select-btn ms-1'>Edit</div>
                            </Link> 
                        </div>
                        </>
                        : <></>
                    }
                    <div className='theme-card-current-text'>Current</div>
                    <div className='theme-card-current-hover-text'>{theme.theme_name}</div>
                    {card}
                </div>
            </div>
        )
    } else {
        return (
            <div className={`theme-card theme-${theme.id}`} ref={cardRef} style={{background: theme.main_background}}>
                {(hover === theme.theme_name && theme.type !== 'default') ?
                    <div className='theme-card-delete' onClick={() => setShowDelete(!showDelete)}>
                        {!showDelete ?
                            <i className='far fa-xmark' style={{pointerEvents: 'none'}} />
                            :
                            <div className='theme-card-delete-words'>
                                Are you sure?
                                <span onClick={() => handleDeleteTheme(theme)}><i className='far fa-check' style={{pointerEvents: 'none'}} /></span>
                                <span />
                                <span onClick={() => setShowDelete(false)}><i className='far fa-xmark' style={{pointerEvents: 'none'}} /></span>
                            </div>
                        }
                    </div>
                    :
                    null
                }
                {hover === theme.theme_name ? 
                    <>
                    <div className='theme-card-hover-text' style={{borderRadius: '.5rem'}}>
                        <div className='theme-card-hover-text-inner'>{theme.theme_name}</div>
                    </div>
                    <div className='theme-card-btns'>
                        {theme.type === 'custom' ?
                            <>
                            <button className='theme-card-select-btn me-1' onClick={() => selectTheme(theme)}>Select</button>
                            <Link 
                                to='/settings/themes/editor'
                                state={{ themeType: theme.type, themeId: theme.id, deleteParam: false }}
                                style={{textDecoration: 'none'}}
                            >
                                <div className='theme-card-select-btn ms-1'>Edit</div>
                            </Link> 
                            </>
                        : (newThemeAllowed) ?
                            (wizard) ?
                                    <button className='theme-card-template-btn' onClick={() => selectTheme(theme)}>Use Template</button>
                                :
                                    <Link 
                                        to={'/settings/themes/editor'}
                                        state={{ themeType: theme.type, themeId: theme.id, deleteParam: false }}
                                        style={{textDecoration: 'none'}}
                                    >
                                            <div className='theme-card-template-btn'>Use Template</div>
                                    </Link>
                            : (wizard) ?
                                <button className='theme-card-template-btn' onClick={() => selectTheme(theme)}>Use Template</button>
                            :
                            <div className='theme-card-template-btn-full' onClick={() => setShowFullMessage(!showFullMessage)}>
                                {showFullMessage ?
                                    <>
                                    <div className='theme-card-full-words'>Are you sure you want to delete your current theme?</div>
                                    <div className='theme-card-yes-no'>
                                        <Link 
                                            to={'/settings/themes/editor'}
                                            state={{ themeType: theme.type, themeId: theme.id, deleteParam: true }}
                                            style={{textDecoration: 'none'}}
                                        >
                                            <div className='theme-card-yes-btn'>Yes</div>
                                        </Link>
                                        <div className='theme-card-no-btn' onClick={() => setShowFullMessage(false)}>No</div>
                                    </div>
                                    </>
                                    : <>Use Template</>
                                }
                            </div> 
                        }
                    </div>
                    </>
                    : null}
                {card}
            </div>
        );
    };
};

export default ThemeCard;